/** Cornerstone (platform owner) organization ID */
export const CORNERSTONE_ORG_ID = '896d5c9e-888f-4a81-97c3-02b42ece8eda'
